import {inject, Injectable} from '@angular/core';
import {AttachNoteFileParams} from "../../../../../features/pages/notes-page/components/modals/note-files-modal/types/note-files-modal.types";
import {AttachFileParams} from "../../../../types/file.types";
import {NoteFilesModalService} from "../../../../../features/pages/notes-page/components/modals/note-files-modal/services/note-files-modal.service";
import {NOTES_FILE_TYPES} from "../../../../constants/files.const";

@Injectable({
  providedIn: 'root'
})
export class ItemPasteProgressModalService {
  private noteFilesModalService: NoteFilesModalService = inject(NoteFilesModalService);

  public async attachFile(attachFileParams: AttachFileParams): Promise<void> {
    switch (attachFileParams.type) {
      case NOTES_FILE_TYPES:
        await this.attachNoteFile(attachFileParams);
        break;
    }
  }

  public async attachNoteFile(attachFileParams: AttachFileParams): Promise<void> {
    const { fileId, parentId } = attachFileParams;
    const attachNoteFileParams: AttachNoteFileParams = {
      noteId: parentId,
      fileId: fileId
    };

    await this.noteFilesModalService.attachNoteFile(attachNoteFileParams);
  }
}
